<script setup>
import Popover from "primevue/popover";
import InputGroup from "primevue/inputgroup";
import InputText from "primevue/inputtext";
import InputGroupAddon from "primevue/inputgroupaddon";
import Button from "primevue/button";
import {computed, ref} from "vue";
import {UseClipboard} from "@vueuse/components";

const op = ref();
const props = defineProps({
    slug: String,
    name: String,
    url: String,
    shareLinks: Object
})
const toggle = (event) => {
    op.value.toggle(event);
}

const getIframe = computed(() => {
    return `<iframe src="${props.url}?embed" title="${props.name}, Roori" frameBorder="0" width="700" height="800">Your browser does not support Roori Embed</iframe>`;
})

const links = computed(() => {
    let links = [];
    for (const [key, value] of Object.entries(props.shareLinks)) {
        links.push({
            value: value,
            key: key
        });
    }
    return links;
})
</script>

<template>
    <Button type="button" v-tooltip.bottom="$t('common.share_embed_tooltip')" rounded icon="pi pi-share-alt" text severity="secondary" @click="toggle"/>

    <Popover ref="op">
        <div class="flex flex-col gap-4 w-[24rem]">
            <div>
                <InputGroup>
                    <InputText :value="url" readonly class="w-[25rem]"></InputText>
                    <UseClipboard v-slot="{ copy, copied }" :source="url">
                        <InputGroupAddon class="cursor-pointer hover:bg-neutral-100 dark:hover:bg-gray-900" @click="copy(url)">
                            <i :class="`pi pi-${copied ? 'check' : 'copy'}`"></i>
                        </InputGroupAddon>
                    </UseClipboard>

                    <UseClipboard v-slot="{ copy, copied }" :source="getIframe">
                        <InputGroupAddon class="cursor-pointer hover:bg-neutral-100 dark:hover:bg-gray-900" @click="copy(getIframe)">
                            <i class="pi pi-code mr-2"></i>
                            <small class="text-neutral-500">{{ copied ? $t('common.share_copied') : $t('common.share_embed_btn') }}</small>
                        </InputGroupAddon>
                    </UseClipboard>
                </InputGroup>
            </div>
            <div class="flex gap-4 justify-between">
                <Button
                    v-for="link in links"
                    :key="link.key"
                    as="a"
                    :href="link.value"
                    target="_blank"
                    rel="noopener"
                    :icon="`pi pi-${link.key}`"
                    severity="secondary"
                    outlined
                />
            </div>
        </div>
    </Popover>
</template>

<style scoped lang="scss">

</style>
